import React, { useState } from "react";
import axios from "axios";
import "../assets/css/changePassword.css";
import Sidebar from "../components/Sidebar";
import StaffSidebar from "../components/StaffSidebar";

const isProduction = process.env.NODE_ENV === "production";
const API_BASE_URL = isProduction
  ? "https://schools.luth.gov.ng"
  : "http://localhost:3003";

export default function StaffChangePassword() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!currentPassword || !newPassword || !confirmPassword) {
      setError("All fields are required.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("New password and confirm password do not match.");
      return;
    }

    if (newPassword.length < 6) {
      setError("New password must be at least 6 characters.");
      return;
    }

    const username = localStorage.getItem("username");
    if (!username) {
      setError("Username not found. Please log in again.");
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      const res = await axios.put(
        `${API_BASE_URL}/api/users/staff-change-password`,
        {
          username,
          currentPassword,
          newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setMessage(res.data.msg || "Password changed successfully.");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      console.error("Change password error:", err);
      setError(
        err.response?.data?.msg ||
          "Unable to change password. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="staff-dashboard" style={{ marginTop: "-130px" }}>
      <StaffSidebar />
      <div className="student-dashboard" style={{ marginTop: "-130px" }}>
        <div className="change-password-page">
          <div className="change-password-card">
            <h2>Change Password</h2>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Current Password</label>
                <input
                  type="password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  placeholder="Enter current password"
                  required
                />
              </div>

              <div className="form-group">
                <label>New Password</label>
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Enter new password"
                  required
                />
              </div>

              <div className="form-group">
                <label>Confirm New Password</label>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm new password"
                  required
                />
              </div>

              {error && <p className="error-text">{error}</p>}
              {message && <p className="success-text">{message}</p>}

              <button
                className="change-button"
                type="submit"
                disabled={loading}
              >
                {loading ? "Updating..." : "Change Password"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
